"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graph = void 0;
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const highcharts_1 = __importDefault(require("highcharts/highcharts"));
const accessibility_1 = __importDefault(require("highcharts/modules/accessibility"));
const no_data_to_display_1 = __importDefault(require("highcharts/modules/no-data-to-display"));
const stock_1 = __importDefault(require("highcharts/modules/stock"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const colors_1 = require("../../../assets/styles/colors");
const store_1 = require("../../../store");
const fixedStreamSelectors_1 = require("../../../store/fixedStreamSelectors");
const fixedStreamSlice_1 = require("../../../store/fixedStreamSlice");
const hooks_1 = require("../../../store/hooks");
const mobileStreamSelectors_1 = require("../../../store/mobileStreamSelectors");
const mobileStreamSlice_1 = require("../../../store/mobileStreamSlice");
const thresholdSlice_1 = require("../../../store/thresholdSlice");
const filters_1 = require("../../../types/filters");
const sensors_1 = require("../../../types/sensors");
const timeRange_1 = require("../../../types/timeRange");
const dateParser_1 = require("../../../utils/dateParser");
const getTimeRange_1 = require("../../../utils/getTimeRange");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const timeRanges_1 = require("../../../utils/timeRanges");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const chartEvents_1 = require("./chartEvents");
const createGraphData_1 = require("./chartHooks/createGraphData");
const updateRangeDisplay_1 = require("./chartHooks/updateRangeDisplay");
const useChartUpdater_1 = require("./chartHooks/useChartUpdater");
const useMeasurementsFetcher_1 = require("./chartHooks/useMeasurementsFetcher");
const S = __importStar(require("./Graph.style"));
const graphConfig_1 = require("./graphConfig");
// Initialize the stock module
(0, stock_1.default)(highcharts_1.default);
// Initialize No-Data and Accessibility modules.
(0, no_data_to_display_1.default)(highcharts_1.default);
(0, accessibility_1.default)(highcharts_1.default);
const Graph = (0, react_1.memo)(({ streamId, sessionType, isCalendarPage, rangeDisplayRef, selectedTimestamp, onDayClick, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const graphRef = (0, react_1.useRef)(null);
    const chartComponentRef = (0, react_1.useRef)(null);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const thresholdsState = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const isLoading = (0, hooks_1.useAppSelector)(store_1.selectIsLoading);
    // Mobile vs. fixed stream info
    const mobileGraphData = (0, hooks_1.useAppSelector)(mobileStreamSelectors_1.selectMobileStreamPoints);
    const mobileStreamShortInfo = (0, hooks_1.useAppSelector)(mobileStreamSelectors_1.selectMobileStreamShortInfo);
    const fixedStreamShortInfo = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamShortInfo);
    // Last selected time range from Redux
    const fixedLastSelectedTimeRange = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectLastSelectedFixedTimeRange);
    const mobileLastSelectedTimeRange = (0, hooks_1.useAppSelector)(mobileStreamSlice_1.selectLastSelectedMobileTimeRange);
    const { unitSymbol, measurementType, isIndoor, sensorName } = (0, mapParamsHandler_1.useMapParams)();
    const isIndoorParameterInUrl = isIndoor === "true";
    const lastSelectedTimeRange = fixedSessionTypeSelected
        ? fixedLastSelectedTimeRange
        : mobileLastSelectedTimeRange || timeRange_1.MobileTimeRange.All;
    const startTime = (0, react_1.useMemo)(() => fixedSessionTypeSelected
        ? (0, dateParser_1.parseDateString)(fixedStreamShortInfo.startTime)
        : (0, dateParser_1.parseDateString)(mobileStreamShortInfo.startTime), [
        fixedSessionTypeSelected,
        fixedStreamShortInfo.startTime,
        mobileStreamShortInfo.startTime,
    ]);
    const endTime = (0, react_1.useMemo)(() => fixedSessionTypeSelected
        ? fixedStreamShortInfo.endTime
            ? (0, dateParser_1.parseDateString)(fixedStreamShortInfo.endTime)
            : Date.now()
        : mobileStreamShortInfo.endTime
            ? (0, dateParser_1.parseDateString)(mobileStreamShortInfo.endTime)
            : Date.now(), [
        fixedSessionTypeSelected,
        fixedStreamShortInfo.endTime,
        mobileStreamShortInfo.endTime,
    ]);
    const totalDuration = (0, react_1.useMemo)(() => endTime - startTime, [startTime, endTime]);
    const measurements = (0, hooks_1.useAppSelector)((state) => (0, fixedStreamSelectors_1.selectStreamMeasurements)(state, streamId));
    const isGovData = sensorName === null || sensorName === void 0 ? void 0 : sensorName.includes(sensors_1.SensorPrefix.GOVERNMENT);
    // Generate chart series data.
    const seriesData = (0, react_1.useMemo)(() => {
        return fixedSessionTypeSelected
            ? (0, createGraphData_1.createFixedSeriesData)(measurements)
            : (0, createGraphData_1.createMobileSeriesData)(mobileGraphData, true);
    }, [fixedSessionTypeSelected, measurements, mobileGraphData]);
    const chartData = seriesData;
    // Local override flag – when true, force computed selected index to -1.
    const [overrideRangeSelector, setOverrideRangeSelector] = (0, react_1.useState)(false);
    // Hooks to fetch & update chart data.
    const { fetchMeasurementsIfNeeded } = (0, useMeasurementsFetcher_1.useMeasurementsFetcher)(streamId, startTime, endTime, chartComponentRef, fixedSessionTypeSelected, rangeDisplayRef, sensorName);
    const { updateChartData, lastTriggerRef } = (0, useChartUpdater_1.useChartUpdater)({
        chartComponentRef,
        seriesData,
        isLoading,
        fixedSessionTypeSelected,
        streamId,
    });
    const isFirstLoadRef = (0, react_1.useRef)(true);
    const lastRangeSelectorTriggerRef = (0, react_1.useRef)(null);
    const lastUpdateTimeRef = (0, react_1.useRef)(0);
    // If the last trigger was a mousewheel event—or if the override flag is true—we force the computed index to -1.
    const computedSelectedRangeIndex = (0, react_1.useMemo)(() => {
        if (selectedTimestamp)
            return -1;
        if (overrideRangeSelector)
            return -1;
        // So we combine it with our override flag.
        if (lastTriggerRef.current === "mousewheel")
            return -1;
        if (lastTriggerRef.current === "zoom")
            return -1;
        if (!fixedSessionTypeSelected) {
            return 2;
        }
        return (0, getTimeRange_1.getSelectedRangeIndex)(lastSelectedTimeRange, fixedSessionTypeSelected);
    }, [
        selectedTimestamp,
        overrideRangeSelector,
        lastSelectedTimeRange,
        fixedSessionTypeSelected,
    ]);
    const [selectedRangeIndex, setSelectedRangeIndex] = (0, react_1.useState)(computedSelectedRangeIndex);
    (0, react_1.useEffect)(() => {
        setSelectedRangeIndex(computedSelectedRangeIndex);
    }, [computedSelectedRangeIndex]);
    // Ref to track if a custom (calendar) day is selected.
    const isCalendarDaySelectedRef = (0, react_1.useRef)(!!selectedTimestamp);
    const lastProcessedTimestampRef = (0, react_1.useRef)(null);
    // When a calendar day is selected, mark the flag and fetch data.
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart))
            return;
        if (!selectedTimestamp) {
            lastProcessedTimestampRef.current = null;
            return;
        }
        if (lastProcessedTimestampRef.current === selectedTimestamp)
            return;
        lastProcessedTimestampRef.current = selectedTimestamp;
        isCalendarDaySelectedRef.current = true;
        const selectedDayStart = selectedTimestamp;
        let selectedDayEnd = selectedDayStart + timeRanges_1.MILLISECONDS_IN_A_DAY - timeRanges_1.MILLISECONDS_IN_A_SECOND;
        const isFirstDay = selectedDayStart <= startTime;
        const isLastDay = selectedDayEnd >= endTime;
        let finalRangeStart = selectedDayStart;
        let finalRangeEnd = selectedDayEnd;
        if (isFirstDay)
            finalRangeStart = startTime;
        if (isLastDay)
            finalRangeEnd = endTime;
        finalRangeStart = Math.max(finalRangeStart, startTime);
        finalRangeEnd = Math.min(finalRangeEnd, endTime);
        (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, finalRangeStart, finalRangeEnd, true);
        if ((_b = chartComponentRef.current) === null || _b === void 0 ? void 0 : _b.chart) {
            const chart = chartComponentRef.current.chart;
            if (chart.xAxis && chart.xAxis[0]) {
                chart.xAxis[0].setExtremes(finalRangeStart, finalRangeEnd, true, false, { trigger: "calendarDay" });
            }
        }
        if (fixedSessionTypeSelected) {
            fetchMeasurementsIfNeeded(finalRangeStart, finalRangeEnd, false, true, "calendarDay");
        }
    }, [
        selectedTimestamp,
        fetchMeasurementsIfNeeded,
        rangeDisplayRef,
        startTime,
        endTime,
        fixedSessionTypeSelected,
    ]);
    const handleRangeSelectorClick = (0, react_1.useCallback)((selectedButton) => {
        var _a, _b;
        setOverrideRangeSelector(false);
        if (selectedButton === 0) {
            setSelectedRangeIndex(-1);
        }
        else {
            setSelectedRangeIndex(selectedButton);
        }
        lastRangeSelectorTriggerRef.current = selectedButton.toString();
        if ((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) {
            const chart = chartComponentRef.current.chart;
            let timeRange;
            if (fixedSessionTypeSelected) {
                switch (selectedButton) {
                    case 0:
                        timeRange = timeRange_1.FixedTimeRange.Day;
                        break;
                    case 1:
                        timeRange = timeRange_1.FixedTimeRange.Week;
                        break;
                    case 2:
                        timeRange = timeRange_1.FixedTimeRange.Month;
                        break;
                    default:
                        timeRange = timeRange_1.FixedTimeRange.Day;
                }
                dispatch((0, fixedStreamSlice_1.setLastSelectedTimeRange)(timeRange));
            }
            else {
                switch (selectedButton) {
                    case 0:
                        timeRange = timeRange_1.MobileTimeRange.FiveMinutes;
                        break;
                    case 1:
                        timeRange = timeRange_1.MobileTimeRange.Hour;
                        break;
                    case 2:
                        timeRange = timeRange_1.MobileTimeRange.All;
                        break;
                    default:
                        timeRange = timeRange_1.MobileTimeRange.All;
                }
                dispatch((0, mobileStreamSlice_1.setLastSelectedMobileTimeRange)(timeRange));
            }
            if (!chart.xAxis || !chart.xAxis[0])
                return;
            const currentExtremes = chart.xAxis[0].getExtremes();
            const viewEnd = Math.min(currentExtremes.max || endTime, endTime);
            let rangeStart = viewEnd;
            let rangeEnd = viewEnd;
            if (!fixedSessionTypeSelected && timeRange === timeRange_1.MobileTimeRange.All) {
                rangeStart = startTime;
                rangeEnd = endTime;
                // Update UI to show the full range without fetching data
                if ((_b = chartComponentRef.current) === null || _b === void 0 ? void 0 : _b.chart) {
                    const chart = chartComponentRef.current.chart;
                    (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, rangeStart, rangeEnd, false);
                    if (chart.xAxis && chart.xAxis[0]) {
                        chart.xAxis[0].setExtremes(rangeStart, rangeEnd, true, false, {
                            trigger: "allButtonClicked",
                        });
                    }
                    return;
                }
            }
            else {
                switch (timeRange) {
                    case timeRange_1.FixedTimeRange.Month:
                        rangeStart = viewEnd - timeRanges_1.MILLISECONDS_IN_A_MONTH;
                        break;
                    case timeRange_1.FixedTimeRange.Week:
                        rangeStart = viewEnd - timeRanges_1.MILLISECONDS_IN_A_WEEK;
                        break;
                    case timeRange_1.FixedTimeRange.Day:
                        rangeStart = viewEnd - timeRanges_1.MILLISECONDS_IN_A_DAY;
                        break;
                    case timeRange_1.MobileTimeRange.FiveMinutes:
                        rangeStart = viewEnd - timeRanges_1.MILLISECONDS_IN_A_5_MINUTES;
                        break;
                    case timeRange_1.MobileTimeRange.Hour:
                        rangeStart = viewEnd - timeRanges_1.MILLISECONDS_IN_AN_HOUR;
                        break;
                }
            }
            rangeStart = !isMobile ? Math.max(rangeStart, startTime) : rangeStart;
            (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, rangeStart, rangeEnd, false);
            if (fixedSessionTypeSelected) {
                fetchMeasurementsIfNeeded(rangeStart, rangeEnd, false, false, "rangeSelectorButton");
            }
            if (chart.xAxis && chart.xAxis[0]) {
                chart.xAxis[0].setExtremes(rangeStart, rangeEnd, true, false, {
                    trigger: "rangeSelectorButton",
                });
            }
        }
    }, [
        fixedSessionTypeSelected,
        dispatch,
        onDayClick,
        rangeDisplayRef,
        startTime,
        endTime,
        fetchMeasurementsIfNeeded,
        isMobile,
    ]);
    (0, react_1.useEffect)(() => {
        if (!fixedSessionTypeSelected &&
            streamId &&
            startTime &&
            endTime &&
            mobileGraphData.length === 0 &&
            isFirstLoadRef.current) {
            fetchMeasurementsIfNeeded(startTime, endTime, false, false, "initial");
        }
    }, [
        fixedSessionTypeSelected,
        streamId,
        startTime,
        endTime,
        mobileGraphData,
        fetchMeasurementsIfNeeded,
    ]);
    const handleChartLoad = (0, react_1.useCallback)(function () {
        return __awaiter(this, void 0, void 0, function* () {
            chartEvents_1.handleLoad.call(this, isCalendarPage, isMobile);
            const chart = this;
            if (chart.xAxis && chart.xAxis[0]) {
                if (fixedSessionTypeSelected) {
                    const oneDayAgo = endTime - timeRanges_1.MILLISECONDS_IN_A_DAY;
                    chart.xAxis[0].setExtremes(oneDayAgo, endTime, true, false);
                }
                else {
                    // Mobile sessions should show the full time range by default
                    chart.xAxis[0].setExtremes(startTime, endTime, true, false);
                }
            }
            isFirstLoadRef.current = false;
        });
    }, [isCalendarPage, isMobile, endTime, startTime, fixedSessionTypeSelected]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) {
            const chart = chartComponentRef.current.chart;
            if (!chart || !chart.xAxis || !chart.xAxis[0]) {
                return;
            }
            let lastExtremes = chart.xAxis[0].getExtremes();
            let debounceTimer = null;
            let isUpdating = false;
            const updateExtremesHandler = (eventType) => {
                if (debounceTimer)
                    clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    if (isUpdating)
                        return;
                    isUpdating = true;
                    try {
                        if (!chart || !chart.xAxis || !chart.xAxis[0]) {
                            return;
                        }
                        const currentExtremes = chart.xAxis[0].getExtremes();
                        if (currentExtremes.min !== lastExtremes.min ||
                            currentExtremes.max !== lastExtremes.max) {
                            lastExtremes = currentExtremes;
                            (0, updateRangeDisplay_1.updateRangeDisplay)(rangeDisplayRef, currentExtremes.min, currentExtremes.max, false);
                            if (streamId) {
                                if (fixedSessionTypeSelected) {
                                    dispatch((0, fixedStreamSlice_1.updateFixedMeasurementExtremes)({
                                        streamId,
                                        min: currentExtremes.min,
                                        max: currentExtremes.max,
                                    }));
                                }
                                else {
                                    dispatch((0, mobileStreamSlice_1.updateMobileMeasurementExtremes)({
                                        min: currentExtremes.min,
                                        max: currentExtremes.max,
                                    }));
                                }
                            }
                        }
                    }
                    finally {
                        isUpdating = false;
                    }
                }, isMobile ? 200 : 100);
            };
            const redrawHandler = () => updateExtremesHandler("redraw");
            const scrollbarHandler = () => updateExtremesHandler("scrollbar");
            const navigatorHandler = () => updateExtremesHandler("navigator");
            const afterSetExtremesHandler = () => updateExtremesHandler("afterSetExtremes");
            highcharts_1.default.addEvent(chart, "redraw", redrawHandler);
            highcharts_1.default.addEvent(chart, "scrollbar", scrollbarHandler);
            highcharts_1.default.addEvent(chart, "navigator", navigatorHandler);
            if (chart.xAxis && chart.xAxis[0]) {
                highcharts_1.default.addEvent(chart.xAxis[0], "afterSetExtremes", afterSetExtremesHandler);
            }
            return () => {
                // Clear timer first
                if (debounceTimer) {
                    clearTimeout(debounceTimer);
                    debounceTimer = null;
                }
                highcharts_1.default.removeEvent(chart, "redraw", redrawHandler);
                highcharts_1.default.removeEvent(chart, "scrollbar", scrollbarHandler);
                highcharts_1.default.removeEvent(chart, "navigator", navigatorHandler);
                if (chart.xAxis && chart.xAxis[0]) {
                    highcharts_1.default.removeEvent(chart.xAxis[0], "afterSetExtremes", afterSetExtremesHandler);
                }
            };
        }
    }, [
        chartComponentRef,
        fetchMeasurementsIfNeeded,
        rangeDisplayRef,
        streamId,
        fixedSessionTypeSelected,
        dispatch,
    ]);
    const options = (0, react_1.useMemo)(() => {
        return {
            chart: Object.assign(Object.assign({}, (0, graphConfig_1.getChartOptions)(isCalendarPage, isMobile)), { events: { load: handleChartLoad } }),
            xAxis: (0, graphConfig_1.getXAxisOptions)(isMobile, fixedSessionTypeSelected, dispatch, fetchMeasurementsIfNeeded, streamId, lastTriggerRef, lastUpdateTimeRef, onDayClick, rangeDisplayRef, startTime, endTime, isCalendarDaySelectedRef, 
            // Pass the setter so that the mousewheel branch can hold the override longer.
            setOverrideRangeSelector),
            yAxis: (0, graphConfig_1.getYAxisOptions)(thresholdsState, isMobile),
            series: [
                Object.assign({}, (0, graphConfig_1.seriesOptions)(chartData)),
            ],
            tooltip: (0, graphConfig_1.getTooltipOptions)(measurementType, unitSymbol),
            plotOptions: (0, graphConfig_1.getPlotOptions)(fixedSessionTypeSelected, streamId, dispatch, isIndoorParameterInUrl, isGovData),
            rangeSelector: Object.assign(Object.assign({}, (0, graphConfig_1.getRangeSelectorOptions)(isMobile, fixedSessionTypeSelected, totalDuration, computedSelectedRangeIndex, isCalendarPage, t)), { buttons: fixedSessionTypeSelected
                    ? [
                        {
                            type: "day",
                            count: 1,
                            text: t("graph.24Hours"),
                            events: {
                                click: function () {
                                    onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(null);
                                    handleRangeSelectorClick(0);
                                },
                            },
                        },
                        {
                            type: "week",
                            count: 1,
                            text: t("graph.oneWeek"),
                            events: {
                                click: function () {
                                    onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(null);
                                    handleRangeSelectorClick(1);
                                },
                            },
                        },
                        {
                            type: "month",
                            count: 1,
                            text: t("graph.oneMonth"),
                            events: {
                                click: function () {
                                    onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(null);
                                    handleRangeSelectorClick(2);
                                },
                            },
                        },
                    ]
                    : [
                        {
                            type: "minute",
                            count: 5,
                            text: t("graph.fiveMinutes"),
                            events: {
                                click: function () {
                                    handleRangeSelectorClick(0);
                                },
                            },
                        },
                        {
                            type: "minute",
                            count: 60,
                            text: t("graph.oneHour"),
                            events: {
                                click: function () {
                                    handleRangeSelectorClick(1);
                                },
                            },
                        },
                        {
                            type: "all",
                            text: t("graph.all"),
                            events: {
                                click: function () {
                                    handleRangeSelectorClick(2);
                                },
                            },
                        },
                    ], selected: selectedTimestamp
                    ? undefined
                    : overrideRangeSelector
                        ? undefined
                        : lastTriggerRef.current === "mousewheel"
                            ? undefined
                            : lastTriggerRef.current === "zoom"
                                ? undefined
                                : selectedRangeIndex >= 0
                                    ? selectedRangeIndex
                                    : undefined }),
            scrollbar: (0, graphConfig_1.getScrollbarOptions)(isCalendarPage, isMobile),
            navigator: (0, graphConfig_1.getNavigatorOptions)(),
            responsive: (0, graphConfig_1.getResponsiveOptions)(thresholdsState, isMobile),
            legend: graphConfig_1.legendOption,
            noData: {
                style: { fontWeight: "bold", fontSize: "15px", color: colors_1.white },
                position: { align: "center", verticalAlign: "middle" },
                useHTML: true,
                text: "No data available",
            },
        };
    }, [
        isCalendarPage,
        isMobile,
        totalDuration,
        computedSelectedRangeIndex,
        t,
        fixedSessionTypeSelected,
        dispatch,
        isLoading,
        fetchMeasurementsIfNeeded,
        streamId,
        lastTriggerRef,
        lastUpdateTimeRef,
        startTime,
        endTime,
        thresholdsState,
        chartData,
        selectedTimestamp,
        selectedRangeIndex,
        overrideRangeSelector,
        onDayClick,
        measurementType,
        unitSymbol,
        isIndoor,
    ]);
    (0, react_1.useEffect)(() => {
        const applyStyles = () => {
            const graphElement = graphRef.current;
            if (graphElement) {
                graphElement.style.touchAction = "pan-x";
                const highchartsContainer = graphElement.querySelector(".highcharts-container");
                if (highchartsContainer) {
                    highchartsContainer.style.overflow = "visible";
                }
                const highchartsChartContainer = graphRef.current.querySelector("[data-highcharts-chart]");
                if (highchartsChartContainer) {
                    highchartsChartContainer.style.overflow = "visible";
                }
            }
        };
        applyStyles();
        const observer = new MutationObserver(applyStyles);
        if (graphRef.current) {
            observer.observe(graphRef.current, { childList: true, subtree: true });
        }
        return () => {
            observer.disconnect();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) &&
            seriesData &&
            seriesData.length > 0) {
            setTimeout(() => {
                var _a;
                if ((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) {
                    chartComponentRef.current.chart.reflow();
                    if (isCalendarPage) {
                        const container = graphRef.current;
                        if (container) {
                            const currentHeight = container.style.height;
                            container.style.height = "auto";
                            container.offsetHeight;
                            container.style.height = currentHeight;
                            setTimeout(() => {
                                var _a;
                                if ((_a = chartComponentRef.current) === null || _a === void 0 ? void 0 : _a.chart) {
                                    chartComponentRef.current.chart.reflow();
                                }
                            }, 100);
                        }
                    }
                }
            }, 200);
        }
    }, [isCalendarPage, seriesData]);
    (0, react_1.useEffect)(() => {
        if (isFirstLoadRef.current &&
            streamId &&
            startTime &&
            endTime &&
            endTime > startTime) {
            isFirstLoadRef.current = false;
            setTimeout(() => {
                fetchMeasurementsIfNeeded(startTime, endTime, true, false, "initial");
            }, 50);
        }
    }, [
        streamId,
        fixedSessionTypeSelected,
        startTime,
        endTime,
        fetchMeasurementsIfNeeded,
    ]);
    return (react_1.default.createElement(S.Container, { "$isCalendarPage": isCalendarPage, "$isMobile": isMobile, "$isLoading": isLoading, ref: graphRef }, seriesData && seriesData.length > 0 && (react_1.default.createElement(highcharts_react_official_1.default, { highcharts: highcharts_1.default, constructorType: "stockChart", options: options, ref: chartComponentRef, immutable: false }))));
});
exports.Graph = Graph;
